import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_RULE_API } from "./apiRoutes";

interface UseGetDistributionRuleProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionRuleByCommunityYear = async (communityId: string, year: string) =>
  await axiosAuth.get(`${DISTRIBUTION_RULE_API(communityId)}/year/${year}`);

const useGetDistributionRuleByCommunityYear = ({
  queryParams,
  communityId,
  year
}: UseGetDistributionRuleProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-rule-community-year", communityId, year],
    queryFn: () => getDistributionRuleByCommunityYear(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!year && !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetDistributionRuleByCommunityYear;
